export type FileSelectAlignment = 'center' | 'left';

export enum FileSelectMode {
  DRAGDROP = 'dragdrop',
  ICON = 'icon',
}

// FIXME: T267853 - We can't directly use the DragEvent type as it breaks Safari in dev mode as
// TypeScript emits it on the method decorated param type. Maybe try to remove
// that hack later when we use Bazel or Ivy.
export type FlDragEvent = DragEvent;
